// extracted by mini-css-extract-plugin
export default {"elementImage":"ElementImage_elementImage__jY0Zh","actionIcon":"ElementImage_actionIcon__LOXLA","premium":"ElementImage_premium__r7jeG","image":"ElementImage_image__Y0kmQ"};